import React, {useState, useEffect} from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../models/device.view-model";
import {ListItemViewModel} from "../../../../infrastructure/models/list-item.view-model";
import {WithDevice} from "../../composers/with-device";
import {SecondaryTab} from "./secondary-tab";
import styles from "../styles/secondary-tabs.module.scss";
import classNames from "classnames";

export class SecondaryTabsProps extends BaseProps {
  initialIndex: Number = 0;
  tabs: Array<ListItemViewModel>;
  device: DeviceViewModel;
  onChange: Function;
}

export const SecondaryTabs = WithDevice((props: SecondaryTabsProps) => {
  const [activeIndex, setActiveIndex] = useState(props.initialIndex);

  useEffect(() => {
    setActiveIndex(props.initialIndex);
  }, [props.initialIndex])

  const onChangeTab = (e, tab) => {
    setActiveIndex(tab.index);
    props.onChange?.(e, tab);
  };

  return (
    <div className={classNames(styles.tabs_container, {[styles.small_view]: props.device.isSmallView})}>
      {
        props.tabs.map((tab: ListItemViewModel) => <SecondaryTab
          tab={tab}
          key={tab.index}
          active={activeIndex === tab.index}
          onClick={(e, tab) => onChangeTab(e, tab)}
        />)
      }
    </div>
  )
});
